import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class CustomerSearch
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: CustomerSearch.Params): Observable<CustomerSearch.Result>
	{
		return this.m_queryInvoker.doQuery("CustomerSearch", params);
	}
};

export namespace CustomerSearch
{
	export class Params
	{
		config?: string;
		includeOwnPrivate?: boolean;
		includeOwnPublic?: boolean;
		includeForeignPublic?: boolean;
		id?: string;
		name?: string;
		street?: string;
		zip?: string;
		city?: string;
		hierarchyNode1?: string;
		hierarchyNode2?: string;
		hierarchyNode3?: string;
		hierarchyNode4?: string;
		country?: string;
		logisticsAreaProxy?: string;
		limit?: number;
	};
	export interface Result
	{
		customers?: Customer[];
		limit?: number;
	};
	export interface Customer
	{
		oid?: string;
		id?: string;
		companyName1?: string;
		companyName2?: string;
		title?: string;
		firstName?: string;
		lastName?: string;
		phoneNumber?: string;
		email?: string;
		hierarchyNode1?: string;
		hierarchyNode2?: string;
		hierarchyNode3?: string;
		hierarchyNode4?: string;
		isPublic?: boolean;
		owner?: Owner;
		street?: string;
		zip?: string;
		city?: string;
		country?: string;
	};
	export interface Owner
	{
		oid?: string;
		fullName?: string;
	};
};
